import React from 'react';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import { ConnectedRouter } from 'react-router-redux';
import { IntlProvider } from 'react-intl';

import createConfigureStore from './store/configureStore';
import Routes from './routes';
import { locale, chooseLocale } from './translations';

const history = createBrowserHistory();

const app = (
  <Provider store={createConfigureStore(history)}>
    <IntlProvider locale={locale} messages={chooseLocale(locale)}>
      <ConnectedRouter history={history}>
        {Routes}
      </ConnectedRouter>
    </IntlProvider>
  </Provider>
);

export default app;
